"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingPlanCreatedBy = exports.InboundSource = exports.ShippingPlanStatus = void 0;
var ShippingPlanStatus;
(function (ShippingPlanStatus) {
    ShippingPlanStatus["ARCHIVED"] = "ARCHIVED";
    ShippingPlanStatus["PENDING"] = "PENDING";
    ShippingPlanStatus["SHIPMENT_CREATED"] = "SHIPMENTS_CREATED";
})(ShippingPlanStatus = exports.ShippingPlanStatus || (exports.ShippingPlanStatus = {}));
var InboundSource;
(function (InboundSource) {
    InboundSource["SELLER"] = "SELLER";
    InboundSource["RETURNS"] = "RETURNS";
    InboundSource["STORAGE"] = "STORAGE";
    InboundSource["STORAGE_TO_ECOM"] = "STORAGE_TO_ECOM";
    InboundSource["STORAGE_INTL"] = "STORAGE_INTL";
    InboundSource["P2P_INTL"] = "P2P_INTL";
    InboundSource["P2P_WITH_PREP"] = "P2P_WITH_PREP";
    InboundSource["CLIENT_APP"] = "CLIENT_APP";
})(InboundSource = exports.InboundSource || (exports.InboundSource = {}));
var ShippingPlanCreatedBy;
(function (ShippingPlanCreatedBy) {
    ShippingPlanCreatedBy["SELLER_PORTAL"] = "SELLER_PORTAL";
    ShippingPlanCreatedBy["SHOPIFY_API"] = "SHOPIFY_API";
    ShippingPlanCreatedBy["DELIVERR_API"] = "DELIVERR_API";
    ShippingPlanCreatedBy["BOOKING_API"] = "BOOKING_API";
    ShippingPlanCreatedBy["BOOKING_API_V2"] = "BOOKING_API_V2";
    ShippingPlanCreatedBy["BOOKING_API_V3"] = "BOOKING_API_V3";
})(ShippingPlanCreatedBy = exports.ShippingPlanCreatedBy || (exports.ShippingPlanCreatedBy = {}));
//# sourceMappingURL=ShippingPlan.js.map